define('Header',[
    'jquery',
    'ANSI/Utility/Dimensions',
    'ANSI/Utility/SitecoreUtils',
    'promise-polyfill',
], function ($, dimensions, sitecoreUtils) {
    'use strict';

    var header = {
        init: function () {
            if ($('.ansi-header').length) {
                header.desktopHover();
                header.dropdownAnimation();
                header.scrollLogic();
                header.backButtonMobile();
                header.mobileLevelOneSlide();
                header.mobileLevelTwoSlide();
                header.navToggle();
                header.pageLinksCloseMenu();
                if (dimensions.width > 991 && $('.score-megamenu-dropdown').length > 0) {
                    header.addActiveState();
                }
                header.currentHoveredLink = undefined;
            }
        },
        desktopHover: function () {
            // Nav menu changed to hover from click event
            if (dimensions.width > 991) {
                $(document).off(
                    'click.bs.tab.data-api',
                    '.ansi-header [data-hover="tab"]'
                );
                $(document).on(
                    'mouseenter.bs.tab.data-api',
                    '.ansi-header [data-toggle="tab"], .ansi-header [data-hover="tab"]',
                    function (e) {
                        e.preventDefault();
                        var self = $(this);
                        var closestTab = self.closest('.ansi-header .score-tab');
                        header.currentHoveredLink = e.currentTarget;
                        setTimeout(function () {
                            if (header.currentHoveredLink === self.tab()[0]) {
                                closestTab.find('li.active').removeClass('active');
                                closestTab.find('.score-tab-panel.active').removeClass('active in');
                                self.tab('show');
                            }
                        }, 300);
                    }
                );
                $(document).on(
                    'mouseleave.bs.tab.data-api',
                    '.ansi-header [data-toggle="tab"], .ansi-header [data-hover="tab"]',
                    function (e) {
                        if ($('.score-tab-panel.active').has(e.target) === 0) {
                            var closestTab = self.closest('.ansi-header .score-tab');
                            closestTab.find('li.active').removeClass('active');
                            closestTab.find('.score-tab-panel.active').removeClass('active in');
                        }
                    }
                );
            }
        },
        addActiveState: function () {
            var prefix = "NavHeader.js -> addActiveState: ";
            // Utility function to convert nodelist to Array
            //to use [...nodeList].forEach -  from es6
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for (
                        var i = 0, arr2 = Array(arr.length);
                        i < arr.length;
                        i++
                    ) {
                        arr2[i] = arr[i];
                    }
                    return arr2;
                } else {
                    return Array.from(arr);
                }
            }

            /* Get the active menu item and add class to nav item */
            // For first level of the mega menu
            var check = $('header ul.nav .score-megamenu-dropdown .dropdown-menu .score-tab .tab-content').find('li.active, li.active-section');
            if (check && check.length > 0) {
                $(check).closest('.score-megamenu-dropdown').addClass('activate');
            }

            // For second level of the mega menu
            var levelTwo = document.querySelector('.ansi-tier-two');
            var levelTwoParents = levelTwo.querySelectorAll('.score-megamenu-dropdown');
            var navItems = levelTwo.querySelectorAll('.score-menu-list .score-menu-list-item > a, .level-1.score-section-menu > li > a');
            var isAlreadyActivated = false;
            var isFoundWithoutHash = false;
            var location = window.location;
            var allLevelTwoMenuItems = [].concat(_toConsumableArray(navItems));

            allLevelTwoMenuItems.forEach(function (el) {
                // console.log(prefix + 'el.pathname: ' + el.pathname + ' location.pathname: ' + location.pathname + '; el.hostname: ' + el.hostname + ' location.hostname: ' + location.hostname + '; el.hash: ' + el.hash + '; location.hash: ' + location.hash/* + '; el.parentNode is active: ' + el.parentNode.classList.contains('active')*/);
                if (el.pathname === location.pathname && el.hostname === location.hostname) {
                    isFoundWithoutHash = true;
                    if (location.hash !== "") {
                        $(el).on('click', function (e) {
                            $(levelTwoParents).removeClass('activate');
                            e.target.closest('.score-megamenu-dropdown').classList.add('activate');
                            // console.log(prefix + 'added onClick to add class activate');
                        });
                        if (el.hash === location.hash) {
                            el.closest('.score-megamenu-dropdown').classList.add('activate');
                            isAlreadyActivated = true;
                            // console.log(prefix + 'added class activate');
                        }
                    } else {
                        if (el.hash === "") {
                            el.closest('.score-megamenu-dropdown').classList.add('activate');
                            // console.log(prefix + 'added class activate');
                        }
                        else {
                            $(el).on('click', function (e) {
                                window.location.hash = e.target.hash;
                                window.location.reload(true);
                                // console.log(prefix + 'added onClick to reload page with the hash');
                            });
                        }
                        isAlreadyActivated = true;
                    }
                }
            });

            if (!isAlreadyActivated && isFoundWithoutHash) {
                allLevelTwoMenuItems.forEach(function (el) {
                    if (el.pathname === location.pathname && el.hostname === location.hostname) {
                        el.closest('.score-megamenu-dropdown').classList.add('activate');
                        // console.log(prefix + 'added class activate using second loop');
                    }
                });
            }
        },
        pageLinksCloseMenu: function () {
            if (dimensions.width < 992) {
                //prevents dropdown from closing when clicked inside only in mobile
                var check = $('.ansi-header .score-tab .score-menu-list-item.active a');
                $(document).on('click', '.score-megamenu .dropdown-menu', function(e) {
                        e.stopPropagation();
                });
                if (check.length > 0) {
                    check.on("click", function (e) {
                        e.stopPropagation();
                        $('.navbar-toggle').trigger("click");
                    });
                }
            } else {
                $(document).on('click', '.score-megamenu .score-megamenu-dropdown .dropdown-menu', function (e) {
                    if (e.target.tagName.toLowerCase() !== 'a') {
                        return false;
                    }
                });
                $(document).on('click.bs.tab.data-api', '.ansi-header [data-toggle="tab"]', function (e) {
                    e.preventDefault();
                    return false;
                });
            }
        },
        backButtonMobile: function (e) {
            //Create a bread crumb in mobile to return to parent from all levels.
            $('.score-button.nav-back-button').on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();
                var scoreMegamenuContents = $('.score-megamenu-content');
                var navbarCollapseCollapseIn = $('.navbar-collapse.collapse.in');
                var scoreTabs = $('.ansi-header .score-tab');
                var crumbName = $(this).closest('.score-megamenu-content .score-style-box').find('span').data('crumb');
                if (navbarCollapseCollapseIn.hasClass('slide') && scoreTabs.hasClass('slide')) {
                    scoreTabs.removeClass('slide');
                    scoreMegamenuContents.find('.score-style-box span').text(crumbName);
                } else if (navbarCollapseCollapseIn.hasClass('slide')) {
                    navbarCollapseCollapseIn.removeClass('slide');
                    setTimeout(function () {
                        scoreMegamenuContents.removeClass('slide-in');
                        $('.score-megamenu-dropdown').removeClass('open');
                    }, 800);
                }
            });
        },
        mobileLevelOneSlide: function () {
            // Slide nav on level on click mobile.
            $('.score-megamenu-dropdown').on("click", function () {
                if (dimensions.width < 992) {
                    var breadCrumb = $(this).find('a').first().text();
                    $(this)
                        .find('.score-megamenu-content')
                        .addClass('slide-in');
                    $(this)
                        .find('.nav.nav-tabs')
                        .find('li')
                        .removeClass('active');
                    $('.navbar-collapse').addClass('slide');
                    $(this)
                        .find('.score-megamenu-content .score-style-box span')
                        .text(breadCrumb)
                        .attr('data-crumb', breadCrumb);
                }
            });
        },
        mobileLevelTwoSlide: function () {
            //Slide to level 2 of tabset in nav mobile menu.
            if (dimensions.width < 992) {
                $(document).on(
                    'click.bs.tab.data-api',
                    '.ansi-header [data-toggle="tab"], .ansi-header [data-hover="tab"]',
                    function () {
                        $(this)
                            .closest('.ansi-header .score-tab')
                            .addClass('slide');
                        var secondBreadCrumb = $(this).text();
                        setTimeout(function () {
                            $(
                                '.score-megamenu-content .score-style-box span'
                            ).text(secondBreadCrumb);
                        }, 100);
                    }
                );
            }
        },
        dropdownAnimation: function () {
            // Added slide up animation for mega menu content.
            if (dimensions.width > 991) {
                $('.score-megamenu-dropdown').on('show.bs.dropdown', function (e) {
                    var dropDown = $(this).find('.dropdown-menu'),
                        origMarginTop = parseInt(dropDown.css('margin-top'));
                    dropDown
                        .css({
                            'margin-top': origMarginTop + 30 + 'px',
                            opacity: 0,
                        })
                        .animate(
                            { 'margin-top': origMarginTop + 'px', opacity: 1 },
                            200,
                            function () {
                                $(this).css({ 'margin-top': '' });
                            }
                        );
                });
            }
        },
        scrollLogic: function () {
            // Watch scroll position to hide and show tier 2 nav menu.
            var lastScrollTop = $('.ansi-tier-two').outerHeight();
            var ticking = false;
            var delay = 250;

            var hasScrolled = function (e) {
                var st = $(window).scrollTop();
                if (dimensions.width > 991) {
                    if (st > 5) {
                        if (st > lastScrollTop) {
                            $('.ansi-tier-two').addClass('slide-out');
                        } else {
                            $('.ansi-tier-two').removeClass('slide-out');
                        }
                    }
                    lastScrollTop = st;
                }
            };

            var timeout;

            window.addEventListener(
                'scroll',
                function (event) {
                    if (timeout) {
                        window.cancelAnimationFrame(timeout);
                    }

                    timeout = window.requestAnimationFrame(function () {
                        hasScrolled();
                    });
                },
                false
            );
        },
        navToggle: function () {
            // Close nav in mobile view it nav item is clicked.
            $('.navbar-toggle').on("click", function () {
                //header.navToggle();
                if ($('.navbar-toggle[aria-expanded="false"]')) {
                    $('.score-tab').removeClass('slide');
                    $('body').removeClass('open');
                    $('.navbar-collapse.collapse.in').removeClass('slide');
                    $('.nav.nav-tabs').removeClass('active');
                    $('.score-megamenu-content').removeClass('slide-in');
                } else {
                    $('body').addClass('open');
                }
            });
        },
    };

    if (!sitecoreUtils.prototype.isEditing())
        Promise.resolve().then(header.init);
});

